export default "__VITE_ASSET__kSBZ_g6s__"